import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { GreenTickGreenCircleGradient } from "components/icons/GreenTickGreenCircleGradient";
import { RightArrow } from "components/icons/RightArrow";
import { useRef } from "react";

type SuccessAndRdHandoffModalProps = {
  isOpen: boolean;
  filingPeriod: string;
  onReviewNow: () => void;
  onDismiss: () => void;
};

export const SuccessAndRdHandoffModal = ({
  isOpen,
  onReviewNow,
  onDismiss,
}: SuccessAndRdHandoffModalProps) => {
  const headingRef = useRef<HTMLHeadingElement>(null);

  return (
    <Modal.Root open={isOpen} onOpenChange={onDismiss}>
      <Modal.Content size="small">
        <div className="t-relative t-p-6">
          <div className="t-absolute t-top-4 t-right-4">
            <Modal.Close />
          </div>
          <div className="t-flex t-justify-center">
            <GreenTickGreenCircleGradient />
          </div>
          <h2
            ref={headingRef}
            tabIndex={-1}
            className="t-text-body-lg t-font-bold t-text-text-100 t-text-center t-mb-0"
          >
            Financials finalized successfully!
          </h2>

          <div className="t-flex t-items-center t-gap-3 t-my-6">
            <div className="t-h-px t-flex-1 t-bg-neutral-10" />
            <span className="t-text-body-sm t-italic t-text-text-30 t-whitespace-nowrap">
              Suggested next steps
            </span>
            <div className="t-h-px t-flex-1 t-bg-neutral-10" />
          </div>

          <h3 className="t-text-body t-font-bold t-text-text-100 t-text-center t-m-0">
            Review potential R&D expenses
          </h3>
          <p className="t-text-body-sm t-text-text-60 t-text-center t-mt-3 t-mb-0">
            During this closing period, we identified a few vendors whose
            expenses may qualify as Research & Development under IRS Section
            174.
          </p>

          <p className="t-text-body-sm t-italic t-text-text-30 t-text-center t-mt-3 t-mb-0">
            Don't worry if you're unsure. Use your best estimate — your Inkle
            tax team will review everything before preparing your tax return.
          </p>

          <div className="t-mt-6 t-flex t-flex-col t-items-center t-gap-3">
            <Button
              type="button"
              customType="primary"
              block
              rightIcon={<RightArrow />}
              onClick={onReviewNow}
            >
              Review expense bifurcation
            </Button>
            <Button type="button" customType="link_neutral" onClick={onDismiss}>
              I'll do this later
            </Button>
          </div>
        </div>
      </Modal.Content>
    </Modal.Root>
  );
};
